import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import { useResetFlowMutation } from '@twisto/api-graphql'
import { ButtonGroup, TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { Modal, ModalCloser } from '@twisto/components/atoms/modal'
import {
  submittingFlowFormAtom,
  useSubmittingWrapper,
} from '@twisto/flow-views/components'
import { useFlow } from '@twisto/flow-views/flow/flow.context'
import { BigTwistoIcon } from '@twisto/icons'

import * as styles from './review-income-start-over-modal.styles'

type Props = {
  opened: boolean
  onClose: () => void
}

export const ReviewIncomeStartOverModal = ({ opened, onClose }: Props) => {
  const { sessionId } = useFlow<'ReviewIncomeStep'>()
  const [submitting] = useAtom(submittingFlowFormAtom)

  const [resetFlow] = useResetFlowMutation({
    variables: {
      auth: { sessionId },
    },
  })
  const submittingWrapper = useSubmittingWrapper()
  const handleSubmitIncorrectCalculation = () => submittingWrapper(resetFlow())

  return (
    <Modal
      aria-labelledby="start-over-modal-title"
      opened={opened}
      onClickOutside={onClose}
    >
      <ModalCloser onClick={onClose} />
      <Headline>
        <HeadlineIcon>
          <BigTwistoIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle titleId="start-over-modal-title">
          <Trans id="flow.reviewIncomeStep.startOverModal.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.reviewIncomeStep.startOverModal.subtitle" />
        </HeadlineSubtitle>
        <HeadlineSubtitle>
          <Trans id="flow.reviewIncomeStep.startOverModal.subtitle2" />
        </HeadlineSubtitle>
      </Headline>

      <ButtonGroup css={styles.buttonGroup}>
        <TextButton
          fullWidth
          disabled={submitting}
          onClick={handleSubmitIncorrectCalculation}
        >
          <Trans id="flow.reviewIncomeStep.startOverModal.resetButton" />
        </TextButton>
        <TextButton
          fullWidth
          color="secondary"
          disabled={submitting}
          onClick={onClose}
        >
          <Trans id="flow.reviewIncomeStep.startOverModal.cancelButton" />
        </TextButton>
      </ButtonGroup>
    </Modal>
  )
}
